import React from 'react';
import New from './new';
import Items from './items';
import request from '../../../request';
import Heading from '../components/heading';

export default class Add extends React.Component {
  constructor() {
    super();
    this.state = {
      data: JSON.parse(localStorage.getItem('add-study')),
      patients: [],
    };
  }

  async componentDidMount() {
    try {
      let data = await request({ url: 'studies/add' });
      localStorage.setItem('add-study', JSON.stringify(data));
      this.setState({ data });
    } catch (e) {
      console.error(e);
    }
  }

  render() {
    let { data, patients } = this.state;
    return (
      <div id="dashboard">
        <Heading title="Add Study" />

        {data
          ? <New
              data={data}
              addPatient={patient =>
                this.setState({ patients: [patient, ...patients] })}
            />
          : null}

        {patients.length
          ? <Items
              patients={patients}
              {...data}
              cancelUpload={patient_name =>
                this.setState({
                  patients: patients.filter(
                    patient => patient.patient_name !== patient_name
                  ),
                })}
            />
          : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/dashboard/add/index.js